import { Component, OnInit, OnDestroy, NgZone, EventEmitter, ViewChild, Input } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap/modal';

import { Subscription } from 'rxjs';

import { CompanyEntityComponent } from './../company-entity/company-entity.component';

import {
    AuthorizationService,
    ToastrService,
    Company,
    Minesite,
    CompanyService,
    MinesiteService,
    ModelService,
    Model
} from './../../../../shared/index';

@Component({
    selector: 'company-filter',
    templateUrl: './company-filter.html',
    standalone: false
})

export class CompanyFilterComponent implements OnInit, OnDestroy {
    @ViewChild('companyFilter') companyFilter: ModalDirective;
    @Input('live') live = true;

    private subscriptions: Subscription[] = [];

    public minesites: Minesite[] = [];
    public models: Model[] = [];

    public selectedMinesites: number[] = [];
    public selectedModels: number[] = [];

    public filterApplied = false;
    public activeCompanies = true;
    public inActiveCompanies = true;
    public name = '';

    constructor(
        private _ngZone: NgZone,
        private _companyService: CompanyService,
        private _minesiteService: MinesiteService,
        private _modelService: ModelService,
        private _toastrService: ToastrService
    ) { }

    ngOnInit(): void {
        this.subscriptions.push(this._minesiteService.minesitesChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.minesites = info;
            });
        }));

        this.subscriptions.push(this._modelService.modelChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.models = info;
            });
        }));

        this.models = this._modelService.models.Data;
        this.minesites = this._minesiteService.minesites.Data;
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    public showFilters(): void {
        this.companyFilter.show();
    }

    public applyFilter(): void {
        if (this.name != '' || this.activeCompanies == false || this.inActiveCompanies == false || this.selectedModels.length > 0 || this.selectedMinesites.length > 0) {
            this.filterApplied = true;
        } else {
            this.filterApplied = false;
        }
        this._companyService.applyFilter(this.name, this.activeCompanies, this.inActiveCompanies, this.selectedMinesites, this.selectedModels, this.live);
        this.companyFilter.hide();
    }

    public clearFilter(): void {
        this.name = '';
        this.activeCompanies = true;
        this.inActiveCompanies = true;
        this.selectedMinesites = [];
        this.selectedModels = [];
        this.filterApplied = false;
    }
}
